import { DESIGNERS, DESIGNER_PORTFOLIO } from './actions'

export default (state = {}, { type, payload }) => {
  switch (type) {
    case DESIGNERS:
      return {
        ...state,
        designersList: payload,
      }
    case DESIGNER_PORTFOLIO:
      return {
        ...state,
        designersPortfolios: {
          ...state.designersPortfolios,
          [payload.id]: payload.data,
        },
      }
    default:
      return state
  }
}
